import { Button, Modal } from "@closer/ui";
import { useState } from "react";

import { ActivityFeed } from "./ActivityFeed";

/**
 * BAĞLAM AKTİVİTESİ PENCERESİ (CLOS-881).
 *
 * ### ⚠ NEDEN VAR: SATIRLAR ÜRETİLİYORDU, SORAN YÜZEY YOKTU
 *
 * `[055]` CLOS-283 aktivite projeksiyonunu `membership`, `department` ve `role`
 * bağlamlarına da yazıyor ve `access.ts` her biri için satır-seviyesi kapıyı tanımlıyor
 * (`organization.member`, `organization.department`, `organization.view`). Ama bu üç
 * bağlamı soran hiçbir ekran yoktu: kullanıcının üyelik geçmişi, bir departmanın ya da
 * rolün aktivitesi hiçbir yerden görülemiyordu. Üretici hazır, kapı yazılı, tüketici yok.
 *
 * ### ⚠ AYRI SAYFA DEĞİL — pencere
 *
 * CLOS-283'ün açık yasağı: *"aktivite ayrı sidebar sayfası değildir; ilgili ... bağlamda
 * gösterilir."* Üç yeni rota açmak o yasağı arka kapıdan delerdi. Bu üç kayıt türünün
 * bugün DETAY SAYFASI da yok (yüzey envanteri: `MembersPage`, `DepartmentsPage`,
 * `RolesPage` — üçü de liste). Pencere, kaydın kendi satırından açılıyor: bağlam
 * korunuyor, yeni bir ürün yüzeyi icat edilmiyor.
 *
 * ### ⚠ YENİ UÇ YOK
 *
 * `GET /api/activity?entityType=...&entityId=...` zaten var ve kapısı satır satır
 * çalışıyor. Kart da *"yeni uç gerekmez"* diyor.
 *
 * ⚠ Akış YALNIZ pencere açıkken kuruluyor: `ActivityFeed` monte edilince sorguyu atıyor.
 * Listedeki her satır için önceden çekseydik, tek bir üye listesi onlarca istek doğururdu.
 */
export function ContextActivityModal({
  entityType,
  entityId,
  baslik,
  dugmeEtiketi = "Geçmiş",
}: {
  entityType: "membership" | "department" | "role";
  entityId: string;
  /** Pencere başlığı: hangi kaydın geçmişine bakıldığı yazılı olmalı. */
  baslik: string;
  /** Erişilebilir ad; listede her satırda aynı metin durduğu için çağıran ayırt eder. */
  dugmeEtiketi?: string;
}) {
  const [acik, setAcik] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        aria-label={`${baslik} geçmişi`}
        onClick={() => setAcik(true)}
      >
        {dugmeEtiketi}
      </Button>
      {acik ? (
        <Modal open onClose={() => setAcik(false)} title={`${baslik} · Geçmiş`}>
          {/*
            ⚠ Yetki kapısı SUNUCUDA ve satır satır: bu pencere hiçbir şeyi gizlemiyor,
            yalnız soruyor. Yetkisi olmayan kullanıcıya uç boş sayfa dönüyor ve
            `ActivityFeed` bunu "kayıt yok" diye anlatıyor — uydurma bir istemci kapısı
            eklemek, sunucununkiyle bir gün ayrışacak ikinci bir kural olurdu.
          */}
          <ActivityFeed entityType={entityType} entityId={entityId} title="Aktivite geçmişi" />
        </Modal>
      ) : null}
    </>
  );
}
